module.exports = function() {
  return new Worker(__webpack_public_path__ + "f5b613653f8936a1bd93.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/libs/markdownWorker.ts
// module id = 1566
// module chunks = 0